import { faMinus } from "@jewlr/pro-regular-svg-icons/faMinus"
import { faPlus } from "@jewlr/pro-regular-svg-icons/faPlus"
import { faSearchPlus } from "@jewlr/pro-regular-svg-icons/faSearchPlus"
import { faSpinner } from "@jewlr/pro-regular-svg-icons/faSpinner"
import PropTypes from "prop-types"
import { useCallback } from "react"
import { useDispatch } from "react-redux"

import { addAddon, removeAddon } from "areas/cart/store/actions"
import Button from "components/ui/button"
import FontAwesomeIcon from "components/ui/font-awesome-icon"
import Image from "components/ui/image"
import { jewlr_t } from "helpers/application"
import { getImgSrcSet } from "helpers/image"
import { cn } from "styles/utils"

import AddonPrice from "./addon-price"

export const QtyBtn = ({ className, ...props }) => (
  <Button
    className={cn(
      "bg-grey-4 text-grey-65 border-y-grey-20 w-38 focus:border-primary focus:outline-hidden h-full items-center justify-center border-y focus:border-2",
      className
    )}
    {...props}
  />
)

const ExclusiveAddon = ({
  disableActions,
  item,
  setAddonInModal,
  toggleAddonModal,
  toggleDisableActions,
}) => {
  const dispatch = useDispatch()

  const removing =
    item.addons.findIndex((addon) => addon.id === disableActions.id) != -1 &&
    disableActions.action === "removing"
  const adding =
    disableActions.id === item.code && disableActions.action === "adding"

  const addExclusiveAddon = useCallback(
    (addon_code, addon_type) => {
      dispatch(
        addAddon(addon_code, addon_type, "cart_desktop", toggleDisableActions)
      )
    },
    [dispatch, addAddon, toggleDisableActions]
  )

  const removeExclusiveAddon = useCallback(
    (addon_id) => {
      dispatch(removeAddon(addon_id, toggleDisableActions))
    },
    [dispatch, removeAddon, toggleDisableActions]
  )

  return (
    <div
      data-cy="cart-exclusive-addon"
      key={`dexaddon-${item.id}-${item.code}`}
    >
      {/* Image */}
      <Button
        aria-labelledby={`cart-addon-${item.code}`}
        className="relative w-full"
        onClick={() => {
          setAddonInModal(item)
          toggleAddonModal(true)
        }}
      >
        <Image
          alt=""
          className="w-full"
          fallback={item.images[0]}
          height="1024"
          sizes="(min-width: 768px) 233px, 45vw"
          srcSet={getImgSrcSet(
            item.images[0].replace(
              sl.config.jewlr_asset_url,
              `${sl.config.jewlr_imgsmbly_url}assets/`
            ),
            1024
          )}
          title={item.title}
          width="1024"
        />
        <FontAwesomeIcon
          className="text-14 absolute right-16 top-16 text-black"
          icon={faSearchPlus}
        />
      </Button>
      <div className="desktop:py-20 py-10">
        <h3
          className="body mb-8 line-clamp-2 h-[calc(1.4em_*_2)] text-ellipsis"
          id={`cart-addon-${item.code}`}
        >
          {item.title}
        </h3>
        {/* Price */}
        <AddonPrice price={item.price} retail_price={item.retail_price} />
        {/* Add to Carts | Details */}
        {item.addons.length === 0 ? (
          <Button
            aria-label={`Add ${item.title} to ${jewlr_t("cart")}`}
            className="text-14 tracking-tightest leading-14 w-100 h-28 rounded-sm p-0 font-medium"
            disabled={adding || removing}
            loading={adding}
            onClick={() => {
              if (disableActions.id === "") {
                addExclusiveAddon(item.code, item.type)
              }
            }}
            variant="primary"
          >
            <FontAwesomeIcon className="text-11 mr-4" icon={faPlus} />
            Add
          </Button>
        ) : (
          <div
            aria-label={`Added ${item.addons.length} ${item.title} to ${jewlr_t(
              "cart"
            )}`}
            className="mb-8 mt-auto flex h-28 items-center justify-start"
          >
            <QtyBtn
              aria-label={`Remove ${item.title} from ${jewlr_t("cart")}`}
              className="border-l-grey-20 rounded-bl-md rounded-tl-md border-l"
              disabled={adding || removing}
              onClick={() => {
                if (disableActions.id === "") {
                  removeExclusiveAddon(item.addons[0].id)
                }
              }}
            >
              <FontAwesomeIcon
                className="text-14 align-text-bottom"
                icon={removing ? faSpinner : faMinus}
                spin={removing}
              />
            </QtyBtn>
            <div className="border-t-grey-20 border-b-grey-20 leading-14 text-12 flex h-full items-center border-b border-t bg-white px-10 py-6 font-medium tracking-tight">
              {item.addons.length}
            </div>
            <QtyBtn
              aria-label={`Add ${item.title} to ${jewlr_t("cart")}`}
              className="border-r-grey-20 rounded-br-md rounded-tr-md border-r"
              disabled={adding || removing}
              onClick={() => {
                if (disableActions.id === "") {
                  addExclusiveAddon(item.code, item.type)
                }
              }}
            >
              <FontAwesomeIcon
                className="text-14 align-text-bottom"
                icon={adding ? faSpinner : faPlus}
                spin={adding}
              />
            </QtyBtn>
          </div>
        )}
      </div>
    </div>
  )
}

ExclusiveAddon.propTypes = {
  disableActions: PropTypes.object,
  item: PropTypes.object,
  setAddonInModal: PropTypes.func,
  toggleAddonModal: PropTypes.func,
  toggleDisableActions: PropTypes.func,
}
QtyBtn.propTypes = {
  className: PropTypes.string,
}

export default ExclusiveAddon
